export enum CardType {
  Lock = 'Lock',
  Shop = 'Shop',
  Alarm = 'Alarm',
}
